<template>
  <div class="ViewCourse">
    <AppHeader content="课程管理|查看课程"></AppHeader>
    <AppBox class="appBox">
      <h5>基础信息</h5>
      <div class="lineStyle"></div>
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="课程标题" prop="name">
          <el-input
              :disabled="true"
              style="width: 33%"
              v-model="formData.name"
              maxlength="12"
              placeholder="不得超过12个文字"
          ></el-input>
        </el-form-item>
        <el-form-item label="课程标签">
          <AppTreeSelect
              style="width: 33%"
              :edit="true"
              :options="options"
              :valueArr="formData.tagValueIdList"
          ></AppTreeSelect>
        </el-form-item>
        <el-form-item label="课程类型" prop="category">
          <el-select
              :disabled="true"
              style="width: 33%"
              v-model="formData.category"
              placeholder="请选择"
          >
            <el-option
                v-for="item in courseTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系列名称">
          <el-input
              style="width: 33%"
              :disabled="true"
              v-model="formData.classSubjectName"
          ></el-input>
        </el-form-item>
        <el-form-item label="老师称呼" prop="nickname">
          <el-input
              style="width: 33%"
              v-model="formData.nickname"
              :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="老师头像">
          <div class="img-container" v-if="formData.materialUrl">
            <img :src="formData.materialUrl" class="avatar" alt=""/>
          </div>
          <div class="blankBox" v-else></div>
        </el-form-item>
        <el-form-item label="学习目标"></el-form-item>
        <el-form-item
            label="目标1"
            :prop="formData.category === 0 ? 'target[0]' : ''"
        >
          <el-input
              placeholder="不得超过28个文字"
              style="width: 50%"
              maxlength="28"
              v-model="formData.target[0]"
              :clearable="true"
              show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="目标2">
          <el-input
              placeholder="不得超过28个文字"
              style="width: 50%"
              maxlength="28"
              v-model="formData.target[1]"
              :clearable="true"
              show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button
            v-if="!skip"
            style="width: 30%"
            type="primary"
            @click="handleClose"
        >关闭
        </el-button>
        <el-button
            v-else
            style="width: 30%"
            type="primary"
            @click="handleViewNext"
        >下一页
        </el-button>
      </div>
    </AppBox>
  </div>
</template>

<script>
import {courseMixins} from "@/pages/CourseManagement/courseMixins";
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "ViewCourse",
  components: {AppTreeSelect, AppHeader, AppBox},
  mixins: [courseMixins],
  data() {
    return {
      skip: false,
      courseTypeOption: [
        {value: 0, label: "互动课程"},
        {value: 1, label: "特色课程"},
      ],
    };
  },
  computed: {
    ...mapState("courseCenter", ["tagCategoryList"]),
  },
  async mounted() {
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.options = this.tagCategoryList.data;
    const detail = JSON.parse(localStorage.getItem("lessonResponseDetail"));
    Object.keys(this.formData).map((key) => {
      this.formData[key] = detail[key];
    });
    if (
        detail.states !== 0 ||
        (detail.states === 0 && detail.skipPageFlag === 2)
    ) {
      this.skip = true;
    }
  },
  methods: {
    ...mapActions("courseCenter", ["getTagCategoryList"]),
    async handleViewNext() {
      await this.$router.push(
          {
            name: "ViewLessonContent",
            params: {
              lessonId: this.$route.params.lessonId,
              version: this.$route.params.version,
              classSubjectId: this.$route.params.classSubjectId,
              classSubjectName: this.$route.params.classSubjectName,
            },
          },
          () => {
          }
      );
    },
    async handleClose() {
      await this.$router.push(
          {
            name: "CourseList",
            params: {
              classSubjectId: this.$route.params.classSubjectId,
              classSubjectName: this.$route.params.classSubjectName,
            },
          },
          () => {
          }
      );
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.ViewCourse {
  .appBox {
    min-height: calc(100vh - 155px);

    ::v-deep .el-input.is-disabled .el-input__inner {
      color: #606266;
      background-color: #ffffff;
      background-image: none;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: default;
    }

    .lineStyle {
      width: 100%;
      height: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;
    }

    .targetBox {
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .img-container {
      width: 70px;
      height: 70px;
      overflow: hidden;
      border-radius: 50%;

      .avatar {
        width: auto;
        height: auto;
        max-width: 70px;
        max-height: 70px;
        min-width: 70px;
        min-height: 70px;
        object-fit: cover;
        object-position: center;
      }
    }

    .blankBox {
      width: 70px;
      height: 70px;
      border: 1px solid #dcdfe6;
      border-radius: 50%;
    }

    .footer {
      margin-top: 50px;
      text-align: center;
    }
  }
}
</style>
